import { ReportsTranslations } from "./models/reports-translaction-model";
import { SupportedLanguages } from "@/lang/lang-settings";
import { ptBR } from "./translactions/pt-BR";
import { enUS } from "./translactions/en-US";

export const reports: Record<SupportedLanguages, ReportsTranslations> = {
  'pt-BR': ptBR,
  'en-US': enUS,
};
